import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { deleteItem } from '../api';

import { call, put } from 'redux-saga/effects';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processDelete(action: any) {
  yield call(deleteItem, action);
  yield put({ ...action, type: AT.ITEM_DELETE_DONE });
}

export default function* deleteItemSaga() {
  yield takeLatest(AT.DELETE_ITEM_SAGA, processDelete);
}
